export enum DayTypes {
  Past = 'past-day',
  Current = 'current-day',
  Off = 'day-off',
  CurrentAndOff = 'current-day day-off'
}
